import { Dialog } from '@base-ui/react/dialog';

import { cn } from '../../../../../utils/cn';

export interface Props extends Dialog.Backdrop.Props {}

export const Backdrop = ({ className, ...restProps }: Props) => {
  const backdropClass = cn(
    'fixed inset-0 bg-background-overlay z-overlay',
    className,
  );
  return (
    <Dialog.Backdrop
      className={backdropClass}
      onClick={event => event.stopPropagation()}
      {...restProps}
    />
  );
};
